/* eslint-disable @next/next/no-img-element */
"use client";

import { ubuntu } from "@/globalConstants";

export default function DharmayanaHero({
  heading = 'Get the complete Dharmayana experience on the',
  headingLang,
}: {
  heading?: string;
  headingLang?: string;
}) {
  return (
    <section id="prarthana-homepage-banner" className="w-full flex justify-center py-5 mt-20">

      {/* Wrapper matches content width: 85% / 2xl:70% */}
      <div className="w-[85%] 2xl:w-[70%]">

        {/* MAIN CONTAINER — image drives the height, content overlays */}
        <div className="relative w-full rounded-[24px] overflow-hidden bg-gradient-to-b from-[#84AB88] to-[#05574E]">
          {/* BACKGROUND IMAGE (naturally sizes the container). One <picture>, so the
              browser downloads only this viewport's copy; CSS-hiding the other
              still fetched it. Lazy: it sits below the fold. Lossless WebP. */}
          <picture>
            <source media="(min-width: 768px)" srcSet="/homepage-banner.webp" width={3120} height={1356} />
            <img
              src="/homepage-banner-mobile.webp"
              alt="Dharmayana Background"
              width={984}
              height={1404}
              loading="lazy"
              decoding="async"
              className="block w-full h-auto rounded-[24px]"
            />
          </picture>

          {/* CONTENT — overlaid on top of the image */}
          <div
            className="
              absolute inset-0 z-10 text-white
              md:text-left md:px-10 md:flex md:flex-col md:items-start md:justify-center md:pt-[10%]
              flex flex-col items-center justify-end text-center
              px-6 pb-[15%] gap-1
            "
          >
            <h3 lang={headingLang} className={`${ubuntu.className} text-[clamp(14px,1.8vw,20px)] font-medium leading-tight ml-0 md:ml-2`}>
              {heading}
            </h3>

            <p className={`${ubuntu.className} text-[clamp(24px,4.8vw,60px)] font-bold leading-tight`}>
              Dharmayana App
            </p>

            <div className="flex gap-4 mt-[clamp(8px,1vw,16px)] flex-row justify-center">
              <a href="https://play.google.com/store/apps/details?id=in.dharmayana.android&pcampaignid=web_share">
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/Play Store Badge.webp`}
                  alt="Google Play"
                  className="h-[clamp(40px,3.5vw,56px)] w-auto hover:scale-110"
                />
              </a>

              <a href="https://apps.apple.com/in/app/dharmayana-hindu-app/id6474740467">
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/iOS Badge.webp`}
                  alt="App Store"
                  className="h-[clamp(40px,3.5vw,56px)] w-auto hover:scale-110"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
